import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromSqlQuery from './sql-query.reducer';

export interface SqlQueryState {
  details: fromSqlQuery.SqlQueryDetailsState;
}

export const reducers: ActionReducerMap<SqlQueryState> = {
  details: fromSqlQuery.reducer
};

export const getSqlQueryState = createFeatureSelector<SqlQueryState>('sqlQuery');

export { SqlQueryDetailsState } from './sql-query.reducer';
